import React, { ReactNode } from "react";

import { Alert, Info, Lock } from "./icons";
import styles from "./fundForm.module.scss";

type TTone = "warn" | "info" | "purple";

const TONES: Record<TTone, { className: string; icon: ReactNode }> = {
  warn: { className: styles.noticeWarn, icon: <Alert color="#ec9523" /> },
  info: { className: styles.noticeInfo, icon: <Info color="#8b8699" /> },
  purple: { className: styles.noticePurple, icon: <Lock size={18} color="#713fff" /> },
};

interface INotice {
  tone?: TTone;
  className?: string;
  children: ReactNode;
}

/** A short explanation the form owes the reader, in the tone of its subject. */
export default function Notice({ tone = "info", className, children }: INotice) {
  const { className: toneClass, icon } = TONES[tone];

  return (
    <div className={`${styles.notice} ${toneClass} ${className ?? ""}`}>
      {icon}
      <div>{children}</div>
    </div>
  );
}
